import { render } from "./Aplicacoes.vue?vue&type=template&id=7975eb14&scoped=true"
import script from "./Aplicacoes.vue?vue&type=script&lang=js"
export * from "./Aplicacoes.vue?vue&type=script&lang=js"

import "./Aplicacoes.vue?vue&type=style&index=0&id=7975eb14&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7975eb14"]])

export default __exports__